import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { HelpWidget } from '@replayio-app-building/help-widget'
import '@replayio-app-building/help-widget/styles.css'
import { store } from '../store/store'

/**
 * Default floating help widget (bottom-right) backed by the AI help
 * assistant. See skills/integrations/helpWidget.md. The chat, element
 * picker, and navigation are handled by the widget; navigation is wired
 * to react-router and a lightweight app-state snapshot is sent with each
 * message for context.
 *
 * `versionCheckUrl` points at the `/api/deployed-version` endpoint (which
 * returns the build's commit SHA). The widget polls it in the background and
 * shows a "new version available" reload prompt once a newer deploy is
 * detected, so users with a stale bundle open are nudged to reload.
 */
export default function AppHelpWidget() {
  const navigate = useNavigate()
  const location = useLocation()

  const onNavigate = useCallback((path: string) => navigate(path), [navigate])

  const getAppState = useCallback(() => {
    const state = store.getState()
    return {
      path: location.pathname + location.search,
      user: state.auth.user ? { name: state.auth.user.name } : null,
    }
  }, [location])

  return (
    <HelpWidget
      appName="Replay Loop Builder"
      theme={{
        primaryColor: '#F02D5E',
        fontFamily:
          "'Inter', 'Inter Variable', 'SF Pro Display', -apple-system, system-ui, 'Segoe UI', Roboto, sans-serif",
      }}
      onNavigate={onNavigate}
      getAppState={getAppState}
      versionCheckUrl="/api/deployed-version"
    />
  )
}
